import { ReactElement, MouseEvent } from 'react';
import { Icon, IconsMap } from '@nx-frontend/shared/ui/icon';
import { TippyTooltip } from '@nx-frontend/shared/ui/tooltip';
import { UiTooltipPosition } from '@nx-frontend/shared/types';
import { NotificationPanelFilterOptionWrap } from './notification-panel-filter-option-wrap';

interface NotificationPanelFilterOptionProps {
  title: string;
  checked?: boolean;
  icon?: ReactElement;
  textSize?: 'sm' | '[13px]';
  disabled?: boolean;
  tooltip?: string;
  size?: 'md' | 'lg';
  inactive?: boolean;
  onClick?: (e: MouseEvent) => void;
}
export function NotificationPanelFilterOption(props: NotificationPanelFilterOptionProps) {
  const { title, checked, icon, textSize = 'sm', disabled, tooltip, size = 'md', inactive, onClick } = props;
  const titleItem = <div className="grow truncate">{title}</div>;
  return (
    <NotificationPanelFilterOptionWrap onClick={onClick} textSize={textSize} disabled={disabled} inactive={inactive}>
      {icon ? <div className="mr-3 shrink-0">{icon}</div> : null}
      {!icon && size === 'lg' ? <div className="size-6 mr-3 shrink-0" /> : null}
      {tooltip ? (
        <TippyTooltip message={tooltip} messageClasses="max-w-48" position={UiTooltipPosition.RIGHT} display="block">
          {titleItem}
        </TippyTooltip>
      ) : (
        titleItem
      )}
      <div>{checked ? <Icon icon={IconsMap.CHECK} className="size-4 text-neutral-500" /> : null}</div>
    </NotificationPanelFilterOptionWrap>
  );
}
